var React = require('react');

function ArrowLineLongRight (props) {
    return React.createElement("symbol",props,React.createElement("path",{"d":"M1.777 5h-1v2h1V5zm48 1l-10-5.774v11.547l10-5.773zm-48 1h39V5h-39v2z"}));
}

ArrowLineLongRight.displayName = "ArrowLineLongRight";

ArrowLineLongRight.defaultProps = {"viewBox":"0 0 50 12"};

module.exports = ArrowLineLongRight;

ArrowLineLongRight.default = ArrowLineLongRight;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/arrow-line-long-right.svg
// module id = 1253
// module chunks = 0